export default "__VITE_ASSET__1b7e1ae8__"